export const checksums = {
  "blog": "v3.5.0--ckuav6EjovLlHoIqwpScAoLWTCELYfK36FwKErXEWUI"
}
export const checksumsStructure = {
  "blog": "jLT2dqe1v3lfzraehLQRdN4F7NNgmR_A3LhYvLObko4"
}

export const tables = {
  "blog": "_content_blog",
  "info": "_content_info"
}

export default {
  "blog": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "slug": "string",
      "date": "date",
      "image": "string",
      "imageAlt": "string",
      "tags": "json",
      "who": "json"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}